export default class UserForm {
  public title: string = '';
  public document: string = '';
  public phone: string = '';
  public email: string = '';
  public password: string = '';
  public confirmPassword: string = '';
  public zipcode: string = '';
  public address: string = '';
  public number: string = '';
  public complement: string = '';
  public neighborhood: string = '';
  public state_id: string = '';
  public city_id: string = '';

  constructor(obj?: {
    title: string;
    document: string;
    phone: string;
    email: string;
    password?: string;
    confirmPassword?: string;
    zipcode: string;
    address: string;
    number: string;
    complement: string;
    neighborhood: string;
    state_id: string;
    city_id: string;
    soya: string;
    corn: string;
    sugarCane: string;
    cotton: string;
    wheat: string;
    coffee: string;
    citrus: string;
    bean: string;
    others: string;
  }) {
    if (obj !== undefined) {
      this.title = obj.title;
      this.document = obj.document;
      this.phone = obj.phone;
      this.email = obj.email;
      this.password = obj.password || '';
      this.confirmPassword = obj.confirmPassword || '';
      this.zipcode = obj.zipcode;
      this.address = obj.address;
      this.number = obj.number;
      this.complement = obj.complement;
      this.neighborhood = obj.neighborhood;
      this.state_id = obj.state_id;
      this.city_id = obj.city_id;
      // this.push_token = obj.push_token;
    }
  }
}
